import { render, staticRenderFns } from "./CategoryWiseReport.vue?vue&type=template&id=1b11f320"
import script from "./CategoryWiseReport.vue?vue&type=script&lang=js"
export * from "./CategoryWiseReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports